import { PaginatedSearchBaseOptionsResult } from 'store/base';
import RouterUtilities from 'helpers/RouterUtilities';

export default class AddressBookItemsRequestViewModel extends PaginatedSearchBaseOptionsResult {
  keyword: string;
  customer: string;
  public parse(location: Location) {
    const obj = RouterUtilities.locationSearchStringParse(location);
    if (!obj) {
      return;
    }

    super.baseParse(obj);
    if ('keyword' in obj && typeof obj.keyword === 'string') {
      this.keyword = obj.keyword;
    }
    if ('customer' in obj && typeof obj.customer === 'string') {
      this.customer = obj.customer;
    }
  }
}
